interface InfoPageHeroProps {
  label: string;
  title: string;
  subtitle?: string;
  image: string;
  alt: string;
}

export default function InfoPageHero({
  label,
  title,
  subtitle,
  image,
  alt,
}: InfoPageHeroProps) {
  return (
    <section className="relative h-[300px] md:h-[400px] overflow-hidden">
      <img
        src={image}
        alt={alt}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-airdoa-navy/50 via-airdoa-navy/40 to-airdoa-navy/60" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <p className="text-xs md:text-sm tracking-ultra text-airdoa-gold mb-3 opacity-0 animate-fade-in">
          {label}
        </p>
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight opacity-0 animate-slide-up animation-delay-200">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 max-w-xl text-sm text-white/70 leading-relaxed opacity-0 animate-slide-up animation-delay-300">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}